import React from 'react';
import { useQuery } from 'react-query';
import { useServiceClient } from 'common';
import { SharedEndPoints } from './query-enum';
import { IGetTextData } from './query-interfaces';

export const useGetTextDataQuery = (appId: string) => {
  const { getData } = useServiceClient();
  const getTextData = React.useCallback(() =>
    getData(`${SharedEndPoints.GET_TEXT_DATA}${appId}`)
      .then((res) => res.json())
      .catch((error) => {
        console.error(error);
        return null;
      })
    , [appId, getData]);

  return useQuery<IGetTextData>(SharedEndPoints.GET_TEXT_DATA, getTextData, { retry: 0 });
};
